import React, { useState } from "react";
import { useGlobalContext } from "../GlobalContext";

function TutupAkuntansi() {
  const { periodeakun, bulan, api } = useGlobalContext();

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const currentYear = periodeakun.toString().substring(0,4)
  const currentMonth = parseInt(periodeakun.toString().substring(4,6)) - 1;

  const nextMonth = (currentMonth + 1) % 12;
  const nextYear = currentMonth === 11 ? parseInt(currentYear) + 1 : currentYear;


  const periodenext = nextYear.toString() + (nextMonth + 1).toString().padStart(2,'0');

   const GetRekAkuntansi = async () => {
    try {
      const response = await api.get(`/api/akuntansi/rekeningperkiraan/${periodeakun}/`);
      return response.data || [];
    } catch (error) {
      console.error("Error fetching simpanan:", error);
      return [];
    }
  };  

    const handleSubmit = async (e) => {
      setLoading(true);
      setMessage("");
      const status = false;
      try {
        await api.patch(`/api/akuntansi/rekeningperkiraanstatus/${periodeakun}/${status}`);
      } catch (error) {
        console.error('Error submittiing data:', error);
        return;
      }
      try {
        const dataRekAkuntansi = await GetRekAkuntansi();
        
        if (!Array.isArray(dataRekAkuntansi)) {
          console.error("Data Simpanan bukan array:");
          return;
        }

        const recordDataRekAkun = dataRekAkuntansi.map((item) => ({
          periode : periodenext,
          kdperk : item.kdperk,
          kdperklama : "-",
          awaldb : item.posisi==="D" ? item.saldo : 0,
          awalkd : item.posisi==="K" ? item.saldo : 0,
          mutasidb : 0,
          mutasikd : 0,
          saldo : item.saldo,
          saldorlbln: 0,
          mutdbth: currentMonth===11 ? 0 : item.mutdbth,
          mutkdth: currentMonth===11 ? 0 : item.mutkdth,
          saldoth: item.saldoth,
          status: "true"
        }))

        try{
          await api.patch(`/api/akuntansi/periode/${periodeakun}/0`);
        }catch (error) {
          console.error('Error submittiing data:', error);
        };

        const periodeNew = {"periode":periodenext,"status":"1"};

        try {
          await api.post('/api/akuntansi/periode', periodeNew);
        }catch (error) {
          console.error('Error submitting data:', error);
        };

        try {
           for (const row of recordDataRekAkun) {
              await api.post(
                `/api/akuntansi/rekeningperkiraanbaru`,
                row
              );
            }      
        } catch (error) {
          console.error('Error submitting data:', error);
        }
        setMessage("Proses tutup akuntansi berhasil!");
        setTimeout(() => {        
          localStorage.removeItem('pengguna'); // Hapus data sesi pengguna
          window.location.href = '/login'; // Redirect ke halaman login
        }, 3000);
    } catch (error) {
      console.error("Error processing tutup akuntansi:", error);
    }      
  };

  return (
    <div className="d-flex justify-content-center align-items-center">
      <div className="card card-info" style={{ width: "400px" }}>
        <div className="card-header text-center">
          <h5 className="card-title">Proses Tutup Akuntansi</h5>
        </div>
        <div className="card-body">
          <div className="form-group row">
            <label className="col-sm-5 col-form-label">Periode</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={`${bulan[currentMonth]} ${currentYear}`} readOnly />
            </div>
          </div>
          <div className="form-group row mt-3">
            <label className="col-sm-5 col-form-label">Periode Selanjutnya</label>
            <div className="col-sm-5">
              <input type="text" className="form-control" value={`${bulan[nextMonth]} ${nextYear}`} readOnly />
            </div>
          </div>          
        </div>
        <div className="card-footer text-right">
          <button type="button" className="btn btn-primary btn-sm" onClick={handleSubmit}>
             {loading ? "Memproses Data..." : "Proses"} 
          </button>          
          {message && 
          <div className="alert alert-info mt-2 text-center" role="alert">{message}
          </div>} 
        </div>
      </div>
    </div>
  );
}

export default TutupAkuntansi;   